import { render, staticRenderFns } from "./SchoolCalendarView.vue?vue&type=template&id=03218628&"
import script from "./SchoolCalendarView.vue?vue&type=script&lang=js&"
export * from "./SchoolCalendarView.vue?vue&type=script&lang=js&"
import style0 from "./SchoolCalendarView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VSheet})
